<!-- @format -->

<textarea-page>
  <style>
    .switchArea * {
      cursor: pointer;
    }
    .tooltip-wrap {
      display: flex;
    }
    .tooltip-wrap .has-tooltip {
      margin-right: 0;
    }
    .count {
      font-size: 1.3rem;
      margin: 10px 0;
    }
  </style>

  <div class="wrapper app" if="{state.debt_note}">
    <section class="form_wrap">
      <div class="form_inner important">
        <h1 class="main_title app">重要なご連絡</h1>

        <p>
          ご利用分のお支払いがエラーにより完了していないため、
          <span class="emphasis">サービスのご利用を停止</span>
          しております。
        </p>
        <p>
          <a href="/setting/status">こちらの画面</a>
          より、未払いの料金のお支払いに進んでください。
        </p>
        <div class="unpaid">
          <p style="margin: 20px 0 20px 0">未払いの内容：{state.debt_note}</p>
        </div>
        <p>
          ※お支払いが完了しましたらフリープランの状態になりますので、
          <br />
          引き続き有料プランをご利用されたい場合は改めて有料プランをご契約ください。
        </p>
      </div>
    </section>
  </div>

  <div class="wrapper app" if="{!state.debt_note}">
    <section class="topics_wrap">
      <p class="topics_heading">大切なお知らせ</p>
      <div class="topics_txt-wrap">
        <p class="topics_txt">
          <a href="/information" target="_blank">
            【重要】決済システム変更に伴うクレジットカード情報更新のお願い
          </a>
        </p>
      </div>
    </section>

    <section class="form_wrap">
      <div class="form_inner">
        <form action="" class="">
          <h1 class="main_title app">解析したい文章を入力してください。</h1>

          <div class="radio_wrap tooltip-wrap">
            <input
              type="radio"
              name="acquisition"
              value="edit"
              id="direct"
              class="radio-input"
              checked="checked"
              onchange="{ onChangeInputType }"
            />
            <label for="direct" class="radio_label">
              テキストを直接入力する
            </label>
            <input
              type="radio"
              name="acquisition"
              value="url"
              id="url"
              class="radio-input"
              onchange="{ onChangeInputType }"
            />
            <label for="url" class="radio_label has-tooltip">
              URLからテキストを取得する
            </label>

            <tooltip
              text="特定のWEBページのURLを指定して、ページ内のテキストを取得します。<br>20000文字以上を超える場合や指定されたWEBページの設計によっては正常に取得できない可能性があります。<br><br>※ページ内全てのテキストとなりますので、解析対象として不要な文字列がある可能性があるのでご注意ください。"
            ></tooltip>
          </div>
          <!--/.radio_wrap-->

          <div
            class="tab_contents { state.data.inputType == 'edit' ? 'active' : '' }"
          >
            <textarea
              name="editText"
              class="form_txt"
              cols="40"
              rows="15"
              onkeyup="{ e => onTextarea(e, 'editText') }"
              onchange="{ e => onTextarea(e, 'editText') }"
            ></textarea>
            <p class="align-r count">
              { state.currentLengthEditText }文字
            </p>
            <p class="notice align-r">
              ※20000文字以上の文章、または全文が日本語以外のテキストの場合は解析することが出来ません。
            </p>
          </div>
          <!--/#tab01-->
          <div
            class="tab_contents { state.data.inputType == 'url' ? 'active' : '' }"
          >
            <div class="url_wrap">
              <input
                type="text"
                name="url"
                class="url-input"
                is="binding"
                data="{ state }"
              />
              <button
                class="button button-tertiary button-add"
                type="button"
                value="取得する"
                onclick="{ onGetUrl }"
              >
                取得する
              </button>
            </div>
            <!--/.url_wrap-->
            <div class="url-output_wrap">
              <div class="url-output_heading">
                <p class="url-output_title">取得したテキスト</p>
                <ul class="url-output_list">
                  <li class="url-output_list-item">{ state.currentUrl }</li>
                </ul>
              </div>
              <!--/.url-output_heading-->
              <textarea
                name="urlText"
                class="form_txt"
                cols="40"
                rows="15"
                placeholder="取得されたテキストがここに入ります。"
                value="{ state.data.urlText }"
                onkeyup="{ e => onTextarea(e, 'urlText') }"
                onchange="{ e => onTextarea(e, 'urlText') }"
              ></textarea>
              <p class="align-r count">
                { state.currentLengthUrlText }文字
              </p>
              <p class="notice align-r">
                ※20000文字以上の文章、または全文が日本語以外のテキストの場合は解析することが出来ません。
              </p>
            </div>
            <!--/.url-output_wrap-->
          </div>
          <!--/#tab02-->

          <div class="checkbox_wrap">
            <input
              type="checkbox"
              name="domainRestricted"
              id="domainRestricted"
              class="checkbox-input"
              onchange="{ onChangeDomainRestricted }"
            />
            <label for="domainRestricted" class="checkbox-parts">
              解析対象範囲のドメインを制限する
            </label>
            <tooltip
              text="解析対象をドメイン単位で制限して解析します。特定のドメイン下だけに限定して重複、類似の可能性が高い文章を探したり、既知のドメインを除外して検索するか選択できます。（除外は複数指定可能ですが、限定で指定できるのは1つだけです）"
            ></tooltip>
          </div>
          <!--/.checkbox_wrap-->

          <domain-list
            if="{ state.data.domainRestricted }"
            domains="{ state.data.domains }"
            on-domain-append="{ onDomainAppend }"
            on-domain-remove="{ onDomainRemove }"
            on-change-domain-restricted-direction="{ onChangeDomainRestrictedDirection }"
            domain-error="{ state.domainError }"
          ></domain-list>

          <div class="similar_wrap">
            <div class="similar_heading">
              <span>類似チェック</span>
              <tooltip
                text="言い回しを変えただけ、安易にリライトしただけの“書いてある内容は同じ”文章も検出します。<br>コピペチェックに加えて類似チェックを行う場合は右にあるスイッチを「ON」にして「解析内容の確認」のボタンを押してください。<br>※類似チェックを行いたい場合は、通常のチケット消費×２のカウント消費が必要になります。"
              ></tooltip>
            </div>
            <div
              class="switchArea"
              onclick="{ e => $(`input[name='similarityCheck']`).click() }"
            >
              <input
                type="checkbox"
                name="similarityCheck"
                is="binding"
                data="{ state.data }"
                val="1"
              />
              <label><span></span></label>
              <div id="swImg"></div>
            </div>
          </div>
          <!--/.similar_wrap-->

          <button
            class="button button-primary js-modal-open"
            type="button"
            value="解析内容の確認"
            data-target="modal01"
            onclick="{ onConfirm }"
          >
            解析内容の確認
          </button>
        </form>
      </div>
      <!--/.form_inner-->
    </section>
    <!--form_wrap-->
  </div>
  <!--/.wrapper-->

  <ticket-modal
    modal-id="{ modalId }"
    ticket-require="{ state.ticketRequire }"
    similarity-check="{ state.data.similarityCheck }"
    on-start-processing="{ onStartProcessing }"
  ></ticket-modal>

  <script>
    import di from "dependeny-injection";
    import routes from "@model/routes.js";
    import tooltip from "@tags/parts/tooltip.riot";
    import domainList from "@tags/parts/domain-list.riot";
    import ticketModal from "@tags/modal/ticket-modal.riot";
    import {
      Textarea,
      TicketRequire,
      api as TextareaApi,
    } from "@model/inputs.js";

    const countEffectiveCharacter = (text) => {
      const trimed_text = text.trim();
      const tag_stripped = trimed_text.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
      const result = tag_stripped.replace(/[\t| |　|\r|\n]/g, '')
      return result.length;
    }

    export default {
      components: {
        tooltip,
        "domain-list": domainList,
        "ticket-modal": ticketModal,
      },
      state: {
        url: "",
        currentUrl: "",
        domainError: "",
        data: null,
        ticketRequire: new TicketRequire(),
        debt_note: null,
        currentLengthUrlText: 0,
        currentLengthEditText: 0
      },
      modalId: "textarea-modal",
      onBeforeMount() {
        this.routes = routes;
        this.state.data = new Textarea();
        (this.state.ticketRequire = new TicketRequire()),
          (this.state.debt_note = di.userStatusApi.debt_note);
      },
      onMounted() {
        di.userStatusApi.on("fetched", (data) => {
          this.update({ debt_note: data.debt_note });
        });
      },
      onTextarea(e, name) {
        this.state.data[name] = e.target.value;
        name == "editText"
          ? this.update({ currentLengthEditText: countEffectiveCharacter(e.target.value) })
          : this.update({ currentLengthUrlText: countEffectiveCharacter(e.target.value) });
      },
      onChangeInputType(e) {
        this.state.data.inputType = e.target.value;
        this.update();
      },
      onChangeDomainRestricted(e) {
        this.state.data.domainRestricted = e.target.checked;
        this.update();
      },
      onChangeDomainRestrictedDirection(e) {
        this.state.data.domainRestrictedDirection = e.target.value;
        this.update();
      },
      onDomainRemove(e, i) {
        this.state.data.removeDomain(i);
        this.update();
      },
      onDomainAppend(e) {
        const url = this.$('input[name="append-domain"]').value;
        this.state.domainError = this.state.data.addDomain(url);
        if (!this.state.domainError) {
          this.$('input[name="append-domain"]').value = "";
        }
        this.update();
      },
      async onGetUrl(e) {
        di.loader.setState(true);
        const res = await TextareaApi.requestUrlContent(this.state.url);
        if (res && res.success) {
          di.toast.push("Urlからテキストを取得しました。", "success");
          this.state.data.urlText = res.text;
          this.state.currentUrl = this.state.url;
          this.update({ currentLengthUrlText: countEffectiveCharacter(res.text) });
        } else {
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.loader.setState(false);
        this.update();
      },
      async onConfirm(e) {
        di.loader.setState(true);
        const res = await TextareaApi.requestTicketRequired(
          this.state.data.similarityCheck ? 2 : 1,
          this.state.data.inputType == "edit"
            ? this.$('textarea[name="editText"]').value
            : this.$('textarea[name="urlText"]').value
        );
        if (res) {
          this.state.ticketRequire.set(
            res,
            di.userStatusApi.info.aquiredTickets
          );
          this.update({ ticketRequire: this.state.ticketRequire });
          window.$(this.$(`#${this.modalId}`)).fadeIn(100);
        }
        di.loader.setState(false);
      },
      async onStartProcessing(e) {
        di.loader.setState(true);
        const res = await TextareaApi.register(
          this.state.ticketRequire.ids,
          this.state.data.domainRestricted,
          this.state.data.domains,
          this.state.data.domainRestrictedDirection
        );
        if (res && res.success) {
          di.toast.push("解析を受け付けました。", "success");
          window.$(this.$(`#${this.modalId}`)).fadeOut(0);
          di.router.push(this.routes.makePath("textarea-registered-page"));
        } else {
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.userStatusApi.fetch();
        di.loader.setState(false);
      },
    };
  </script>
</textarea-page>
